import { render, staticRenderFns } from "./Moni1.vue?vue&type=template&id=4f018b7b&scoped=true&"
import script from "./Moni1.vue?vue&type=script&lang=js&"
export * from "./Moni1.vue?vue&type=script&lang=js&"
import style0 from "./Moni1.vue?vue&type=style&index=0&id=4f018b7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f018b7b",
  null
  
)

export default component.exports